// test1222
(1222 && 0);
